import { ChangeDetectionStrategy } from '@angular/core';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

export interface LabelValueInputResult {
  label: string
  value: string
}

@Component({
    selector: 'app-label-value-input',
    templateUrl: './label-value-input.component.html',
    styleUrls: ['./label-value-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class LabelValueInputComponent implements OnInit {

  @Input() labelHtmlId: string | undefined
  @Input() valueHtmlId: string | undefined

  @Input() title: string = ''
  @Input() resetAfterCommit: boolean = false
  @Input() labelFieldPlaceholder: string = ''
  @Input() valueFieldPlaceholder: string = ''

  @Input() labelFormControl!: FormControl<string | null>
  @Input() valueFormControl!: FormControl<string | null>

  @Output() commit = new EventEmitter<LabelValueInputResult>()

  @ViewChild('value') valueInputElement!: ElementRef
  @ViewChild('label') labelInputElement!: ElementRef

  editingMode: 'label' | 'value' = 'label'
  preventTriggerSemaphor = true

  constructor() { }

  ngOnInit(): void {
  }

  switchToValueMode() {
    if (!this.preventTriggerSemaphor) return
    else this.preventTriggerSemaphor = false

    if (this.labelFormControl.valid) {
      this.editingMode = 'value'
      setTimeout(() => {
        this.valueInputElement.nativeElement.focus()
      }, 0)
    }

    setTimeout(() => {
      this.preventTriggerSemaphor = true
    }, 1);
  }

  switchToLabelMode() {
    if (!this.preventTriggerSemaphor) return
    else this.preventTriggerSemaphor = false

    if (this.valueFormControl.value == '') {
      this.editingMode = 'label'
      setTimeout(() => {
        this.labelInputElement.nativeElement.focus()
      }, 0)
    }

    setTimeout(() => {
      this.preventTriggerSemaphor = true
    }, 1);
  }

  onCommit() {
    if (!this.preventTriggerSemaphor) return
    else this.preventTriggerSemaphor = false

    if (this.valueFormControl.valid) {

      this.commit.emit({
        label: this.labelFormControl.value!,
        value: this.valueFormControl.value!
      })

      this.editingMode = 'label'
      this.valueInputElement.nativeElement.blur();

      if (this.resetAfterCommit)
        setTimeout(() => {
          this.labelFormControl.setValue('')
          this.valueFormControl.setValue('')

          this.labelFormControl.markAsPristine()
          this.valueFormControl.markAsPristine()

          this.labelInputElement.nativeElement.focus()
        }, 0)
    }

    setTimeout(() => {
      this.preventTriggerSemaphor = true
    }, 1);
  }


}
